export const commonTooltips = {
  searchVolume: (
    <p style={{ textAlign: 'right' }}>
      علت عدم نمایش میزان جستجو کلمه چی هست؟ <br />
      یک: کلمه طولانی و فاقد جستجوی زیاد <br />
      دو: کلمه غلط املایی داره <br />
      سه: کلمه جستجویی نداره <br />
      چهار: کلمه غیرمجاز هست <br />
      پنج: کلمه دارای نیم فاصله هست <br />
      شش: کلمه خارج از قوانین موتورجستجوی گوگل هست <br />
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://help.mizfa.tools/reason-for-not-displaying-keyword-search-volume/"
      >
        (اطلاعات بیشتر)
      </a>
    </p>
  )
};
